/* eslint-disable max-lines */
/* eslint-disable max-depth */
/* eslint-disable max-len */
/* eslint-disable max-lines */
/* eslint-disable complexity */
import _ from 'lodash';
import DateRangePicker from 'vue2-daterange-picker';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import VueSlider from 'vue-slider-component';
import commonFunctions from '../../common-functions';
export default {
    name: 'Conciliation2Bank',
    extends: commonFunctions,
    components: {
        DateRangePicker,
        VueSlider
    },

    props: {
        data: {
            type: Array,
            required: true
        },
        checks: {
            type: Boolean,
            required: false,
            default: true
        },
        icons: {
            type: Boolean,
            required: false,
            default: true
        },
        actions: {
            type: Boolean,
            required: false,
            default: false
        },
        details: {
            type: Boolean,
            required: false,
            default: true
        },
        filter: {
            type: Boolean | String,
            required: false,
            default: 'all'
        },
        sortable: {
            type: Boolean,
            required: false,
            default: false
        },
        editable: {
            type: Boolean,
            required: false,
            default: false
        },
        sortBy: {
            type: String,
            required: false,
            default: 'fecha_valor'
        },
        sortDesc: {
            type: Boolean,
            required: false,
            default: true
        },
        scrollTop: {
            type: Number,
            required: false,
            default: 50
        },
        settedFilters: {
            type: Object,
            required: false,
            default: () => ({})
        },
        maxAmount: {
            type: Number,
            required: false,
            default: 1000000
        },
        minAmount: {
            type: Number,
            required: false,
            default: 0
        },
        fullScreen: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    /**
     * @override
     */
    data() {
        return {
            product: '',
            currency: '',
            updateKey: 0,
            savingNote: false,
            fields: [
                {
                    key: 'show_checks',
                    label: '',
                    thClass: this.checks ? 'checks_tr' : 'd-none',
                    tdClass: this.checks ? 'px-0 text-center checks_td' : 'd-none'
                },
                {
                    key: 'show_icons',
                    label: '',
                    thClass: this.icons ? '' : 'd-none',
                    // tdClass: this.icons ? 'px-0 text-center d-flex align-items-center pt-3' : 'd-none'
                    tdClass: this.icons ? 'px-0 text-center' : 'd-none'
                },
                {
                    key: 'fecha_operacion',
                    label: 'Fecha operación',
                    thClass: 'fecha_tr',
                    sortable: this.sortable,
                    tdClass: 'fecha_td',
                    formatter: value => {
                        return this.$moment(new Date(value)).format('DD-MMM-YYYY');
                    }
                },
                {
                    key: 'fecha_valor',
                    label: 'Fecha valor',
                    thClass: 'fecha_tr',
                    sortable: this.sortable,
                    tdClass: 'fecha_td',
                    formatter: value => {
                        return this.$moment(new Date(value)).format('DD-MMM-YYYY');
                    }
                },
                {
                    key: 'concept',
                    label: 'Concepto',
                    thClass: 'concept_tr',
                    tdClass: 'concept-td',
                    sortable: this.sortable
                },
                {
                    key: 'importe',
                    label: 'Cantidad',
                    thClass: 'text-right amount_tr',
                    tdClass: 'text-right color-brand amount_td',
                    sortable: this.sortable
                    // formatter: value => {
                    //     return value ? `${this.$options.filters.yuriDecimals(value, 2)} €` : 'N/C';
                    // }
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: this.actions ? 'actions_tr' : 'd-none',
                    tdClass: this.actions ? 'actions_td' : 'd-none'
                }
            ],
            filters: {
                fecha_valor: this.settedFilters.fecha_valor || {
                    startDate: null,
                    endDate: null
                },
                fecha_operacion: this.settedFilters.fecha_operacion || {
                    startDate: null,
                    endDate: null
                },
                concept: this.settedFilters.concept || '',
                importe: this.settedFilters.importe || false
            },
            filtering: false,
            loadingMore: false,
            timeOutFilter: null,
            timeOutFilterTime: 1500,
            localeDateRange: {
                direction: 'ltr',
                format: 'dd/mm/yyyy',
                separator: ' - ',
                daysOfWeek: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'],
                monthNames: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
                firstDay: 1
            },
            rangeOpened: false,
            datepickerEndTanscationDate: '',
            datepickerEndOperationDate: '',
            showHeaders: true,
            lastChecked: null,
            shiftPressed: false,
            newFechaValor: null,
            newFechaOperacion: null,
            newConcept: null,
            newAmount: null
        };
    },

    watch: {
        datepickerEndDate(val) {
            this.filters['fecha_valor'].startDate = val[0];
            this.filters['fecha_valor'].endDate = val[1];
            this.changeColumnFilter('fecha_valor');
        },
        datepickerEndOperationDate(val) {
            this.filters['fecha_operacion'].startDate = val[0];
            this.filters['fecha_operacion'].endDate = val[1];
            this.changeColumnFilter('fecha_operacion');
        },
        $route: {
            /**
             * Comprobamos con un watch si la URL ha cambiado y obtenemos los datos
             */
            handler() {
                this.product = this.$route.query.product;
                this.currency = this.$route.query.currency;
            }
        }
    },

    methods: {
        emitBankOperationsToResume(item) {

            const { reconciliation } = item;
            const { isChecked } = this.$refs[`checkbox__${item.uuid}`];

            if (reconciliation && (reconciliation.status === 'AGRUPADO')) {

                if (reconciliation.status === 'CONCILIADO') {
                    this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/disableAll`, true);
                }

                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/disableGroups`, true);
                // Flag para controlar que se está editando un agrupado
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setGroupedSelected`, true);
                // Flag para guardar el UUID reconciliación
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setUuidGroupedSelected`, item.uuid_reconciliation);
                // Agrupado
                if (isChecked) {
                    // Deseleccionar todos los demás
                    this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/removeBankOperationsSelected`);
                    this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/removeRDOperationsSelected`);
                    // Obtenemos los elementos agrupados de esa transferencia
                    this.$paymentsService
                        .getReconciliation2Info(item.uuid_reconciliation)
                        .then(res => {
                            this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/setComment`, res.data.reconciliation.comment);
                            this.autoSelectElements(res.data.reconciliation, `Conciliation2Detail${this.product}-${this.currency}`);
                        })
                        .catch(err => console.error(err));
                }
            } else {
                // No agrupado
                this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/disableGroups`, true);
            }

            if (isChecked) {
                if (this.lastChecked && this.shiftPressed) {
                    this.shiftPressed = false;
                    const lastRowElement = this.$refs[`checkbox__${this.lastChecked.uuid}`].$el.closest('tr');
                    const lastIndex = Array.from(lastRowElement.parentNode.children).indexOf(lastRowElement);
                    const actualRowElement = this.$refs[`checkbox__${item.uuid}`].$el.closest('tr');
                    const actualIndex = Array.from(actualRowElement.parentNode.children).indexOf(actualRowElement);
                    if (lastIndex < actualIndex) {
                        const arrayOfRows = lastRowElement.parentNode.children;
                        for (let index = lastIndex + 1; index < actualIndex; index++) {
                            const element = arrayOfRows[index];
                            if (!element.getElementsByTagName('input')[0].checked) {
                                element.getElementsByTagName('input')[0].checked = true;
                                const e = {};
                                e.target = element.getElementsByTagName('input')[0];
                                this.$refs[element.getElementsByTagName('input')[0].id].handleChange(e);
                            }
                            // element.getElementsByTagName('input')[0].onchange();
                        }
                    } else {
                        const arrayOfRows = lastRowElement.parentNode.children;
                        for (let index = lastIndex - 1; index > actualIndex; index--) {
                            const element = arrayOfRows[index];
                            if (!element.getElementsByTagName('input')[0].checked) {
                                element.getElementsByTagName('input')[0].checked = true;
                                const e = {};
                                e.target = element.getElementsByTagName('input')[0];
                                this.$refs[element.getElementsByTagName('input')[0].id].handleChange(e);
                            }
                            // element.getElementsByTagName('input')[0].onchange();
                        }
                    }
                } else {
                    this.lastChecked = item;
                }
            } else {
                this.lastChecked = null;
            }
            this.bankOperationsToStore(item, isChecked ? 'add' : 'remove', `Conciliation2Detail${this.product}-${this.currency}`);
        },

        isActive(item, type) {
            const index = _.findIndex(this.bankOperationsSelected, item);
            if (type === 'row-details') {
                return 'bg-greybody';
            }
            if (!item || type !== 'row') {
                return false;
            }
            if (index >= 0) {
                return 'table-success';
            }
            return '';
        },

        isDisabled(item) {
            const disableChecks = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/disableGroups`];
            const disableAll = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/disableAll`];
            return (item.reconciliation && disableChecks) || disableAll ? true : false;
        },

        removeBankOperation(item) {
            // Eliminar item de la store (en el resumen)
            this.$store.dispatch(`Conciliation2Detail${this.product}-${this.currency}/removeBankOperation`, item);
        },

        changeColumnFilter(filter) {
            clearTimeout(this.timeOutFilter);
            let timeOutFilter = this.timeOutFilterTime;
            if (filter === 'fecha_valor' || filter === 'fecha_operacion' || filter === 'importe') {
                timeOutFilter = 0;
            }
            this.timeOutFilter = setTimeout(() => {
                this.filtering = true;
                this.$root.$emit('filter_columns_bankOperations', this.filters);
            }, timeOutFilter);
        },

        clearColumnFilter(filter) {
            if (filter === 'fecha_valor' || filter === 'fecha_operacion') {
                this.filters[filter] = {
                    startDate: null,
                    endDate: null
                };
            } else {
                this.filters[filter] = false;
            }
            this.filtering = true;
            this.$root.$emit('filter_columns_bankOperations', this.filters);
        },

        sortingChanged(state) {
            this.filtering = true;
            this.$root.$emit('filter_bankOperations', state);
        },

        clearAll() {
            this.filtering = true;
        },

        toggleRange() {
            this.rangeOpened = !this.rangeOpened;
            if (!this.filters['importe']) {
                this.filters['importe'] = [this.minAmount, this.maxAmount];
            }
        },

        setFiltering() {
            this.filtering = true;
        },

        showModalNewMovementBank() {
            this.$bvModal.show('modalNewMovementBank');
        },
        hideModalNewMovementBank() {
            this.$bvModal.hide('modalNewMovementBank');
        },
        createNewMovementBank() {
            const payload = {
                product: this.product,
                currency: this.currency,
                fecha_valor: this.newFechaValor,
                fecha_operacion: this.newFechaOperacion,
                concept: this.newConcept,
                amount: this.newAmount
            };
            this.$paymentsService
                    .createBankOperation(payload)
                    .then(() => {
                        this.$emit('fetch_data');
                    })
                    .catch(err => {
                        this.$toast.error(err.name, err.message);
                    })
                    .finally(() => {
                        this.$bvModal.hide('modalNewMovementBank');
                    });
        },
        toggleFilters() {
            this.showHeaders = !this.showHeaders;
        },
        onKeyUp() {
            this.shiftPressed = false;
        },
        onKeyDown(e) {
            if (e.keyCode === 16) {
                this.shiftPressed = true;
            }
        },
        parseRegistroscomplementariosconcepto(registro) {
            let parsedText = '';
            for (let index = 0; index < registro.length; index++) {
                const element = registro[index];
                parsedText += `${element.concepto1.trim()} ${element.concepto2.trim()} - `;
            }
            // Quitamos los últimos tres caracteres (' - ') y los primeros cuatro (código que viene en el fichero y no necesitamos)
            return parsedText.slice(0, -3).substring(4);
        }
    },
    computed: {
        bankOperationsAmmount() {
            let total = 0;
            this.data.forEach(item => {
                total += +item.importe;
            });
            return total;
        },
        seleccionados: {
            get() {
                const items = this.$store.getters[`Conciliation2Detail${this.product}-${this.currency}/bankOperations`];
                if (items) {
                    const actives = items.map(x => x.uuid);
                    return actives;
                } else {
                    return [];
                }
            },
            set(newName) {
                return newName;
            }
        },
        canSendNewMovement() {
            return this.newFechaValor && this.newFechaOperacion && this.newConcept && this.newAmount;
        }
    },
    mounted() {
        this.product = this.$route.query.product;
        this.currency = this.$route.query.currency;
        if (this.sortable) {
            if (this.scrollTop) {
                this.$refs['bankOperations-table'].$el.scrollTop = this.scrollTop;
            }
        }
        document.addEventListener('keyup', this.onKeyUp);
        document.addEventListener('keydown', this.onKeyDown);
    },
    /**
     * @override
     */
    beforeDestroy() {
        document.removeEventListener('keyup', this.onKeyUp);
        document.removeEventListener('keydown', this.onKeyDown);
    }
};
